@if (result() === 'success') {
    <p-message severity="success">
        <i class="pi pi-check" style="font-size: 1.0rem"></i>&nbsp;Deeplink was successful for course code {{courseCode()}}. Please wait while the page redirects..
    </p-message>
}

@if (result() === 'failure') {
    <p-message severity="error">
        <i class="pi pi-times" style="font-size: 1.0rem"></i>&nbsp;Deeplink failed for course code {{courseCode()}}, you will not be redirected - Please contact tech support.
    </p-message>
}
@if (result() === 'more-than-one-course-selected') {
    <p-message severity="error">
        <i class="pi pi-times" style="font-size: 1.0rem"></i>&nbsp;Deeplink was interrupted for course code {{courseCode()}}, you need to restart the process and make sure to select one course only. 
    </p-message>
}